export default __webpack_public_path__ + "static/media/reg_step1_mobile.b1d4dbd8.webp";